import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const IRIS: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Iris,
    name: 'iris',
    displayName: 'IRIS'
};
